import About from "../components/About";
import FeaturedBooks from "../components/FeaturedBooks";
import Contact from "../components/Contact";


const Home = () => {
    return (<div>
        <About />
        <FeaturedBooks />
        <Contact />
    </div>);
};

export default Home;